import { Box, Typography } from "@mui/material";

export default function FourthRow() {
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
        backgroundColor: "#FFBC99",
        paddingTop: { xs: "0", md: "50px" },
      }}
    >
       {/* lewa kolumna w poprzednim ukladzie (teraz jest w komponencie Row) */}

      {/* prawa kolumna */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          flex: { xs: "none", md: "1 1 auto" },
          p: { xs: 2, md: 4 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Usługi projektowe obejmują całość prac związanych z procesem projektu informatycznego.

        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Nasza firma zapewnia profesjonalną obsługę na wszystkich poziomach trwania projektu – począwszy od analizy i prac koncepcyjnych poprzez stworzenie projektu, wdrożenie koncepcji, a skończywszy na szeroko pojętym nadzorze nad projektem.

        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          W ramach tej usługi oferujemy wysoko wykwalifikowanych konsultantów, posiadających interdyscyplinarne doświadczenie w tworzeniu koncepcji systemów informatycznych.

        </Typography>
    
      </Box>
    </Box>
  );
}
